import { createStore, applyMiddleware } from 'redux';
import ReduxThunk from 'redux-thunk';
import promise from 'redux-promise';
import reducers from './reducers';
import { reauthenticate, logout } from './actions/userActions';

// logger
const createStoreWithMiddleware = applyMiddleware(promise, ReduxThunk)(createStore);

// eslint-disable-next-line import/no-mutable-exports
let store = null; // store will contain the redux state

// remove Redux devtools for prod
if (process.env.NODE_ENV === 'production') {
  store = createStoreWithMiddleware(reducers);
} else {
  store = createStoreWithMiddleware(
    reducers,
    window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(),
  );
}

store = createStoreWithMiddleware(reducers);

store.dispatch(
  reauthenticate(
    response => {
      if (!response.account) {
        store.dispatch(logout());
      }
    },
    () => {
      store.dispatch(logout());
    },
  ),
);

export default store;



// WEBPACK FOOTER //
// ./src/reduxStore.js